import { render, staticRenderFns } from "./copyrule.vue?vue&type=template&id=3c893fb6"
import script from "./copyrule.vue?vue&type=script&lang=js"
export * from "./copyrule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports